import { SkillData } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { ListFieldInfo } from '../../../common/list/list-types';
import { SkillTrainingOfferingListEntry } from './../training-offering-lists/skill-training-offering-list-view';
import { TrainingOfferingListEntry } from '../training-offering-lists/training-offering-list-view';

/// View driven from Skill to list of Training Offerings
export const SkillToTrainingOfferingListView: ListFieldInfo<SkillTrainingOfferingListEntry, SkillData>[] = [
  {
    name: 'trainingOfferingTitle',
    label: 'Training Offering Title',
    kind: 'mappedLink',
    map: (entry, data) => {
      if (data) {
        const offering = data.trainingOfferings.find(item => item.id === entry.trainingOfferingId);
        if (offering) {
          return offering.value.title;
        }
      }
      return 'notfound';
    },
    displayed: true,
    sortable: true,
    searchable: true,
    searchOption: (entry, data) => {
      if (data) {
        const offering = data.trainingOfferings.find(item => item.id === entry.trainingOfferingId);
        if (offering) {
          return { label: offering.value.title, value: offering.id };
        }
      }
      return undefined;
    },
    filterField: 'trainingOfferingId'
  },
  {
    name: 'trainingOfferingDescription',
    label: 'Description',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const offering = data.trainingOfferings.find(item => item.id === entry.trainingOfferingId);
        if (offering) {
          return offering.value.description;
        }
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false,
    searchable: false,
    maxWidth: 'Medium'
  },
  {
    name: 'method',
    label: 'Relevance',
    kind: 'action',
    fieldType: 'number',
    read: entry => {
      return entry.method.kind === 'relevance' ? (entry.method.value as number) : '';
    },
    displayed: true,
    align: 'centre'
  },
  {
    name: 'deleteSkillTrainingOffering',
    label: 'Remove',
    kind: 'delete',
    displayed: true,
    align: 'centre'
  }
];

export const UnassignedTrainingOfferingListView: ListFieldInfo<TrainingOfferingListEntry, undefined>[] = [
  {
    name: 'title',
    label: 'Training Offering Title',
    kind: 'link',
    displayed: true,
    sortable: true,
    searchable: true,
  },
  {
    name: 'description',
    label: 'Description',
    kind: 'text',
    displayed: true,
    sortable: true,
    maxWidth: 'Medium'
  },
  {
    name: 'removeTrainingOfferingFromUnassignedList',
    label: 'Add Offering',
    kind: 'delete',
    displayed: true,
    align: 'centre'
  }
];

export const AssignedTrainingOfferingListView: ListFieldInfo<SkillTrainingOfferingListEntry, SkillData>[] = [
  {
    name: 'title',
    label: 'Linked Training Offering Title',
    kind: 'mapped',
    map: (entry, data) => {
      if (data) {
        const offering = data.trainingOfferings.find(to => to.id === entry.trainingOfferingId);
        if (offering) return offering.value.title;
      }
      return 'notfound';
    },
    displayed: true,
    sortable: false,
    searchable: false,
  },
  // {
  //   name: 'providerName',
  //   label: 'Learning Provider',
  //   kind: 'mapped',
  //   map: (entry, data) => {
  //     if (data) {
  //       const offering = data.trainingOfferings.find(to => to.id === entry.trainingOfferingId);
  //       if (offering) {
  //         const provider = ... TODO
  //         return 'notfound';
  //     }
  //     return 'notfound';
  //   },
  //   displayed: true,
  //   sortable: false,
  // },
  {
    name: 'method',
    label: 'Relevance',
    kind: 'mapped',
    map: (entry) => {
      return entry.method.kind === 'relevance' ? (entry.method.value) : '';
    },
    displayed: true,
    sortable: false,
  },

]


// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/skill-lists/skill-to-training-offering-list-view.ts